import React, { useEffect, useState } from "react";
import { Col, Divider, Button, Tag, Tabs, Popover, Radio, Space, Tooltip, Modal, message, Affix } from "antd";
import { EditFilled, ClockCircleOutlined, MobileOutlined, TabletOutlined, DesktopOutlined, BulbOutlined, BulbFilled, SettingOutlined, LeftOutlined, BackwardOutlined, EllipsisOutlined, DoubleRightOutlined } from '@ant-design/icons';
import icon from "../media/icon.png";
import logo_light from "../media/logo_light.png";
import { useSession } from "../utils/Session";
import ContentPanel from "./ContentPanel";
import StylesPanel from "./StylesPanel";
import OrganizePanel from "./OrganizePanel";
import { EyeIcon, EyeSlashIcon } from "./Icons";
import { usePrefs } from "../utils/Prefs";
import { useTemplate } from "../utils/Template";
import { apiCall } from "../utils/Api";
import { tt_monitor_preview, tt_phone_view, tt_tablet_preview } from "../utils/Utils";

export default function Settings(props) {

  const { templates = [], editing = false, filters = { visible: true, hidden: true, test: true, scheduled: true }, setFilters = () => { }, globalTarget = false, setGlobalTarget = () => { }, updateContent = () => { }, selected = "", setSelected = () => { }, view = "desktop", setView = () => { }, setMenus = () => { }, menus = [], theme = {}, setPage = () => { }, setToOpenPage = () => { }, page = {}, content = [], setContent = () => { } } = props;

  const [session, setSession] = useSession();
  const [template, setTemplate] = useTemplate();
  const [prefs, setPrefs] = usePrefs();
  const [showTools, setShowTools] = useState(true);

  const [tab, setTab] = useState("1");


  useEffect(() => {

    if (editing && prefs.changed) {

      Modal.confirm({
        title: "Save Changes?",
        content: "You've made changes to your template, would you like save these changes or revert?",
        okText: "Save",
        cancelText: "Revert",
        onOk: () => {
          save();
        },
        onCancel: () => {
          revert();
        }
      })

    }

  }, [editing])


  const toggleOpen = (_v) => {
    window.scrollTo(0, 0);
    setOpen(_v);
    setSession({ ...session, ["is_editing"]: _v })
  }


  const { setOpen, open } = props;


  const tab_items = [
    { label: <small>Content</small>, key: '1', children: <div className="settings-content" style={{ "overflow": "auto", height: "calc(100vh - 119px)" }}><ContentPanel globalTarget={globalTarget} setGlobalTarget={setGlobalTarget} /></div> }, // remember to pass the key prop
    { label: <small>Styles</small>, key: '2', children: <div className="settings-content" style={{ "overflow": "auto", height: "calc(100vh - 119px)" }}><StylesPanel templates={templates} /></div> },
    { label: <small>Menu</small>, key: '3', children: <div className="settings-content" style={{ "overflow": "auto", height: "calc(100vh - 119px)" }}><OrganizePanel updateContent={updateContent} selected={selected} setSelected={setSelected} setToOpenPage={setToOpenPage} setPage={setPage} page={page} content={content} setContent={setContent} menus={menus} setMenus={setMenus} /></div> }
  ];


  const save = (_tab) => {
    apiCall("site_content/setTemplate", {
      ...template,
      colours: JSON.stringify(template.colours),
      gradients: JSON.stringify(template.gradients),
      buttons: JSON.stringify(template.buttons),
      texts: JSON.stringify(template.texts),
      fonts: JSON.stringify(template.fonts),
      links: JSON.stringify(template.links)
    }, (_status, _result) => {
      if (_status) {
        setTemplate(_result);
        message.success("Saved!")
      } else {
        message.error(_result.error)
      }
      setPrefs({ ...prefs, "changed": false })
      setTab(_tab)
    })
  }

  const revert = (_tab) => {

    apiCall("site_content/getTemplates", {}, (_status, _result) => {
      if (_status) {
        if (_result.length > 0) {
          setTemplate(_result.find(item => item.id === template.id));
          message.success("Template reverted.")
        } else {
          message.error(_result.error)
        }
      } else {
        message.error(_result.error)
      }
      setPrefs({ ...prefs, "changed": false })
      setTab(_tab)
    })
  }


  const drawViewportOptions = (_size = 0, _direction = "horizontal") => {
    return (
      <Space direction={_direction} size={0}>
        <Tooltip placement="right" title={tt_phone_view}>
          <Button onClick={() => { setView("phone"); window.scrollTo(0, 0); }} style={{ "color": (view === "phone") ? "#1890ff" : "#AAA" }} type="text" size="small" value={1}><small><MobileOutlined /></small></Button >
        </Tooltip>
        <Tooltip placement="right" title={tt_tablet_preview}>
          <Button onClick={() => { setView("tablet"); window.scrollTo(0, 0); }} style={{ "color": (view === "tablet") ? "#1890ff" : "#AAA" }} type="text" size="small" value={2}><small><TabletOutlined /></small></Button >
        </Tooltip>
        <Tooltip placement="right" title={tt_monitor_preview}>
          <Button onClick={() => { setView("desktop"); window.scrollTo(0, 0); }} style={{ "color": (view === "desktop") ? "#1890ff" : "#AAA" }} type="text" size="small" value={3}><small><DesktopOutlined /></small></Button >
        </Tooltip>
      </Space>

    )
  }


  return (
    <>

      <div className="brand shadow">
        <div className="float-flex" style={{ "height": "40px", "alignItems": "center", "padding": "10px", "position": "relative", "zIndex": "20" }}>
          <div style={{ "fontSize": "18px" }}>
            <strong>Webstore Designer</strong>
            <a href="/" target="_blank" style={{"fontSize" : "10px", "fontWeight" : "500", "marginTop" : "-5px", "display" : "block"}}>Return to Biz →</a>
          </div>
          <Button disabled={editing} onClick={() => toggleOpen(!open)} size="small" type="primary" ><small>Preview</small></Button>
        </div>
      </div>


      {((!open) && <div className="preview-panel" style={{ "left": (open) ? "-35px" : "15px" }}>

        <Space size={5} direction="vertical">
          <Button size="small" block type={(open) ? "text" : "primary"} onClick={() => toggleOpen(!open)}><small><LeftOutlined /></small></Button>

          <Divider style={{ "margin": "2px 0px" }} dashed />
          {(!showTools) && <>
            <Button onClick={() => { setShowTools(!showTools) }} style={{ "color": (view === "desktop") ? "#1890ff" : "#AAA" }} type="text" size="small" value={3}><small><EllipsisOutlined /></small></Button >
          </>}

          {(showTools) && <>
            <Space size={5} direction="vertical">
              <Tooltip placement="right" title={<small>Show / Hide components flagged as visible.</small>}>
                <Button size="small" block type={(open) ? "text" : "text"} onClick={() => setFilters({ ...filters, "visible": !filters.visible })}>{(filters.visible) ? <EyeIcon style={{ "color": "#3c8617" }} /> : <EyeSlashIcon style={{ "color": "#3c8617", "opacity": "0.5" }} />}</Button>
              </Tooltip>
              <Tooltip placement="right" title={<small>Show / Hide components flagged as draft.</small>}>
                <Button size="small" block type={(open) ? "text" : "text"} onClick={() => setFilters({ ...filters, "test": !filters.test })}>{(filters.test) ? <EyeIcon style={{ "color": "#e77e21" }} /> : <EyeSlashIcon style={{ "color": "#e77e21", "opacity": "0.5" }} />}</Button>
              </Tooltip>
              <Tooltip placement="right" title={<small>Show / Hide components that are not currently scheduled to be visible.</small>}>
                <Button size="small" block type={(open) ? "text" : "text"} onClick={() => setFilters({ ...filters, "scheduled": !filters.scheduled })}>{(filters.scheduled) ? <ClockCircleOutlined style={{ "color": "#0842a0", "fontSize": "12px" }} /> : <ClockCircleOutlined style={{ "color": "#AAA", "opacity": "0.5", "fontSize": "12px" }} />}</Button>
              </Tooltip>
              <Divider style={{ "margin": "0px 0px" }} dashed />
              {drawViewportOptions(5, "vertical")}
              <Divider style={{ "margin": "0px 0px" }} dashed />
              <Button onClick={() => { setShowTools(!showTools) }} style={{ "color": (view === "desktop") ? "#1890ff" : "#AAA" }} type="text" size="small" value={3}><small><DoubleRightOutlined rotate={270} /></small></Button >
            </Space>
          </>}


        </Space>





      </div>)}

      <div style={{ "position": "absolute", "zIndex": "100", "right": "10px", "padding": "12px 3px" }}>
        {drawViewportOptions()}
      </div>

      <Tabs onChange={(e) => {

        if (prefs.changed) {
          Modal.confirm({
            title: "Save Changes?",
            content: "You've made changes to your template, would you like save these changes or revert?",
            okText: "Save",
            cancelText: "Revert",
            onOk: () => {
              save();
            },
            onCancel: () => {
              revert();
            }
          })
        } else {
          setTab(e)
        }



      }} activeKey={tab} items={tab_items} className="settings-tabs" type="card" size="small" defaultActiveKey="1" />




    </>)

}